<template>
  <div class="absolute top-0 inset-x-1.5 sm:inset-x-0.5 z-0 py-0.5" :style="`background:${backgroundColor};`">
    <AnimatedProgressBar :percentage="percentage"
                         :customBarColor="barColor"
                         :customTrackColor="trackColor"
                         :customStripeColor="stripeColor"
                         :custom-border-radius-px="0"
                         progress-bar-height="0.625rem"
                         custom-padding="0"
                         always-show-stripes/>
  </div>
</template>

<script setup>
import {computed, inject} from "vue";
import {addOpacityToHex} from "../helpers/Color";
import AnimatedProgressBar from "./AnimatedProgressBar.vue";

const props = defineProps({
  currentStep: Number,
  totalSteps: Number,
});

const typeformData = inject("typeformData", {});

const percentage = computed(() => Math.max(0, Math.min(1, props.currentStep / Math.max(1, (props.totalSteps - 1)))));
const barColor = computed(() => addOpacityToHex(typeformData.primaryForeground, 0.8));
const trackColor = computed(() => addOpacityToHex(typeformData.primaryForeground, 0.4));
const stripeColor = computed(() => addOpacityToHex(typeformData.primaryForeground, 1));
const backgroundColor = computed(() => addOpacityToHex(typeformData.primaryBackground, 1));
</script>
